import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
} from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VerificationCodeModal from './VerificationCodeModal';
import { useDispatch } from 'react-redux';
import { verifyEmail, sendVerificationCode } from '../store/auth';
import CloseIcon from '@mui/icons-material/Close';

const ResetPasswordModal = ({ open, onClose }) => {
  const [verificationOpen, setVerificationOpen] = useState(false);
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();

  const handleClose = () => {
    setEmail('');
    setVerificationOpen(false);
    if (onClose) onClose();
  };

  const handleVerifyEmail = async () => {
    if (!email) {
      toast.error("Email is required", { theme: "dark" });
      return;
    }

    try {
      const resultAction = await dispatch(verifyEmail(email));

      if (verifyEmail.fulfilled.match(resultAction)) {
        await handleSendVerificationCode();
      } else {
        toast.error(resultAction.payload || "Email n'existe pas ou n'est pas encore confirmé.", {
          theme: "dark"
        });
      }
    } catch (error) {
      toast.error('Failed to verify email. Please try again.', {
        theme: "dark"
      });
    }
  };

  const handleSendVerificationCode = async () => {
    try {
      await dispatch(sendVerificationCode({ email }));

      toast.success('Verification code sent successfully!', {
        theme: "dark"
      });
      setVerificationOpen(true);
      handleClose();
    } catch (error) {
      toast.error('Failed to send verification code. Please try again.', {
        theme: "dark"
      });
    }
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <ToastContainer />
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#3c3c3c',
            color: '#A68E5D',
            borderRadius: 2,
            maxWidth: '400px',
            width: '100%',
            padding: '20px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
          },
          '& .MuiBackdrop-root': {
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 10, right: 10, color: '#A68E5D' }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            color: '#A68E5D',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            fontSize: '1.5rem',
            textAlign: 'center',
          }}
        >
          Reset Password
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputLabelProps={{
              style: { color: 'white' },
            }}
            InputProps={{
              style: {
                backgroundColor: 'transparent',
                color: 'white',
                borderRadius: '15px',
              },
            }}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'white' },
                '&:hover fieldset': { borderColor: 'white' },
                '&.Mui-focused fieldset': { borderColor: 'white' },
              },
              '& .MuiInputLabel-outlined.Mui-focused': {
                color: 'white',
              },
            }}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleVerifyEmail}
            sx={{
              backgroundColor: 'grey',
              color: 'white',
              mt: 2,
              padding: '10px',
              fontSize: '1rem',
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            Send Verification Code
          </Button>
        </DialogContent>
      </Dialog>

      {verificationOpen && (
        <VerificationCodeModal 
          open={verificationOpen}
          onClose={() => setVerificationOpen(false)} 
        />
      )}
    </Box>
  );
};

export default ResetPasswordModal;